import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  IFitoList,
  IFitoListSettings,
} from '~/Components/FitoList/FitoListUncontrolled/interfaces';
import { Route } from '~/Constants/Routes.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { Navigate, useNavigation } from '~/Hooks';
import { IStudio } from '~/Models/DTO/Studio.model';
import { IOrgStudioList } from '~/Models/interfaces/OrgStaff.model';
import { Avatar } from '~/UIKit';

export const useOrgStudioList = ({ pageSize }: { pageSize: number }) => {
  // hooks
  const { navigate } = useNavigation();
  const { t } = useTranslation();

  const keyOfId: keyof IStudio = 'uuid';
  const settings: IFitoListSettings = {
    search: true,
    pagination: true,
    headerPagination: {
      skip: 0,
      take: pageSize,
    },
  };

  const createListItem = (navigate: Navigate, item: IOrgStudioList) => ({
    header: item.name,
    subheader: item.email,
    onClick: () => {
      navigate(routeReplacer(Route.PROVIDER_DETAIL, { domain: item.primaryDomain || '' }));
    },
    actions: [{ name: 'test', onClick: () => {} }],
    picture: <Avatar imageUrl={item.coverurl} />,
  });

  const setItemValues = (item: IStudio): IFitoList => createListItem(navigate, item);

  return {
    title: t('organisation.yourStudios'),
    keyOfId,
    settings,
    setItemValues,
  };
};
